<template>
    <div>
        <div class="container">
            <div class="form-box">
                <el-form ref="form" label-width="120px">

                    <el-form-item label="摄像头监控">
                        <el-switch v-model="systemConfig.enableCamera" @change="changeEnableCamera"></el-switch>
                    </el-form-item>
                    <el-form-item label="支付宝支付">
                        <el-switch v-model="systemConfig.enableAlipay" @change="changeEnableAlipay"></el-switch>
                    </el-form-item>
                    <el-form-item label="微信支付">
                        <el-switch v-model="systemConfig.enableWxpay" @change="changeEnableWxpay"></el-switch>
                    </el-form-item>
                </el-form>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'systemConfig',
        data: function(){
            return {
                systemConfig : {
                    enableCamera: false,
                    enableAlipay: false,
                    enableWxpay: false
                },
                player:null,
            }
        },
        mounted() {

        },
        created: function() {
            this.getData();
        },
        methods: {
            async getData() {
                let res = await this.$axios.get('/manage/systemConfig/getSystemConfig');
                if (res.code != 200) {
                    this.$message.error("获取系统配置数据失败");
                    this.systemConfig = {};
                    return;
                }
                this.systemConfig = res.data;
            },
            async changeEnableCamera(isEnable) {
                let res = await this.$axios.post('/manage/systemConfig/updateSystemConfig',{enableCamera: isEnable});
                this.getData();
            },
            async changeEnableSwitchCount(isEnable) {
                // this.$set(this.systemConfig, 'maxSwitchCount', -1* this.systemConfig.maxSwitchCount);
                let res = await this.$axios.post('/manage/systemConfig/updateSystemConfig',{enableSwitchCount: isEnable});
                // this.changeMaxSwitchCount(-1*this.systemConfig.maxSwitchCount);
                this.getData();
            },
            async changeMaxSwitchCount(count) {
                let res = await this.$axios.post('/manage/systemConfig/updateSystemConfig', {maxSwitchCount: count});
                this.getData();
            },
            async changeEnableAlipay(isEnable) {
                let res = await this.$axios.post('/manage/systemConfig/updateSystemConfig',{enableAlipay: isEnable});
                this.getData();
            },
            async changeEnableWxpay(isEnable) {
                let res = await this.$axios.post('/manage/systemConfig/updateSystemConfig',{enableWxpay: isEnable});
                this.getData();
            },
        }
    }
</script>
